import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from '../components/router/link';
import * as actionCreators from '../actions/auth';
import { Notifs } from 'redux-notifications';
import moment from 'moment';

export class MainLayout extends React.Component {

	render () {
		var border = {
			border: '1px solid red',
		};
		return(
			<div className="ui grid">
				<header className="sixteen column row">
					<div id="left" className="three wide column">
						<img alt="" style={{ width: '70px' }} src={'/css/img/glasstechnika-logo.png'} />
					</div>
					<div id="right" className="thirteen wide column">
						<div className="ui blue buttons right">
							<div className="ui compact menu">
								<div className="ui simple dropdown item">
									<i className="user icon"></i>
									{this.props.user.userName != undefined ? this.props.user.userName : ''}
									<i className="dropdown icon"></i>
								<div className="menu">
									<div className="item" onClick={this.props.actions.logoutAndRedirect}>wyloguj</div>
								</div>
							</div>
							</div>
						</div>
					</div>
				</header>
				<div id="top-page" className="sixteen wide column">
					<div id="menu-top" className="ui menu">
						<Link pathname="customer/order">
							<a className="item">Moje zlecenia</a>
						</Link>
						<Link pathname="customer/invoice">
							<a className="item">Moje faktury</a>
						</Link>
						<Link pathname="customer/update">
							<a className="item">Dane firmy</a>
						</Link>
						<Link pathname="sample_hardening" query={{month: moment().format('MM'), year: moment().format('YYYY')}}>
							<a className="item">Próbki hartu</a>
						</Link>
					</div>
				</div>
				<div className="sixteen wide column">
					<div className="content-page">
						{this.props.children}
					</div>
				</div>
				<footer className="footer">
					<div className="container">
						<p className="pull-left">© glasstechnika.pl 2016</p>
					</div>
				</footer>
				<Notifs />
			</div>);
	}

}

const mapStateToProps = (state) => ({
	user   : state.auth,
});

const mapDispatchToProps = (dispatch) => ({
	actions : bindActionCreators(actionCreators, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(MainLayout);



/** WEBPACK FOOTER **
 ** ./js/layouts/MainLayout.js
 **/